import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { BreadCrumb } from "primereact/breadcrumb";
import { Button } from "primereact/button";
import { FilterTags } from "components/FilterTags";
import { PageRequestError } from "components/PageRequestError";
import { Paginator } from "primereact/paginator";
import { Title } from "components/Title";
import useApp from "hooks/useApp";
import { useNavigate } from "react-router-dom";
import useListPage from "hooks/useListPage";
import usePostForm from "hooks/usePostForm";
import CustomDataTable from "components/CustomDataTable";
const OrgListPage = (props) => {
  const [load, setLoad] = useState(false);
  const app = useApp();
  const navigate = useNavigate();
  const filterSchema = {
    search: {
      tagTitle: "Search",
      value: "",
      valueType: "single",
      options: [],
    },
  };
  const pageController = useListPage(props, filterSchema, "data");
  const { isLicenseKeyValid, validateLicense } = usePostForm({});
  const filterController = pageController.filterController;
  const { t } = useTranslation();
  const FACILITIES = t("FACILITIES");
  const CREATE_NEW_FACILITY = t("CREATE_NEW_FACILITY");
  const FACILITY_NAME = t("FACILITY_NAME");
  const CODE = t("CODE");
  const CONTACT_INFORMATION = t("CONTACT_INFORMATION");

  const {
    records,
    pageReady,
    loading,
    selectedItems,
    sortBy,
    sortOrder,
    apiRequestError,
    setSelectedItems,
    getPageBreadCrumbs,
    onSort,
    deleteItem,
    pagination,
  } = pageController;
  const {} = filterController;
  const {
    totalRecords,
    totalPages,
    recordsPosition,
    firstRow,
    limit,
    onPageChange,
  } = pagination;

  const handleRowClick = (event) => {
    const rowData = event.data;
    navigate(`/org/view/${rowData.code}`);
  };
  function EmptyRecordMessage() {
    if (pageReady && !records.length) {
      return (
        <div className="text-lg mt-3 p-3 text-center text-400 font-bold">
          {t("NO_FACILITIES_FOUND")}
        </div>
      );
    }
  }

  function PagerControl() {
    setLoad(true);
    if (props.paginate && totalPages > 1) {
      const pagerReportTemplate = {
        layout: pagination.layout,
        CurrentPageReport: (options) => {
          return (
            <>
              <span className="text-sm text-gray-500 px-2">
                {FACILITIES}{" "}
                <b>
                  {recordsPosition} {t("OF")} {options.totalRecords}
                </b>
              </span>
            </>
          );
        },
      };
      return (
        <div className="flex-grow-1">
          <Paginator
            first={firstRow}
            rows={limit}
            totalRecords={totalRecords}
            onPageChange={onPageChange}
            template={pagerReportTemplate}
          />
        </div>
      );
    }
    setLoad(false);
  }
  function PageFooter() {
    if (pageReady && props.showFooter) {
      return (
        <div className="flex flex-wrap justify-content-between">
          {/* <MultiDelete /> */}
          <PagerControl />
        </div>
      );
    }
  }
  function PageBreadcrumbs() {
    if (props.showBreadcrumbs) {
      const items = getPageBreadCrumbs();
      return items.length > 0 && <BreadCrumb className="mb-3" model={items} />;
    }
  }
  useEffect(() => {
    validateLicense(null, "org");
  }, []);

  if (apiRequestError) {
    return <PageRequestError error={apiRequestError} />;
  }
  return (
    <main id="orgListPage" className="main-page">
      {props.showHeader && (
        <section className="page-section mb-3">
          <div className="container-fluid">
            <div className="flex justify-content-between align-items-center">
              <Title
                title={FACILITIES}
                titleClass="text-2xl text-primary font-bold"
                subTitleClass="text-500"
                separator={false}
              />
              <Button
                label={CREATE_NEW_FACILITY}
                icon="pi pi-plus"
                type="button"
                className="p-button-primary"
                onClick={() => app.navigate(`/org/add`)}
                disabled={!isLicenseKeyValid}
                tooltip={
                  !isLicenseKeyValid
                    ? t("UPGRADE_LICENSE_CREATE_FACILITIES")
                    : ""
                }
                tooltipOptions={{
                  showOnDisabled: true,
                  position: "left",
                }}
              />
            </div>
          </div>
        </section>
      )}
      <section className="page-section ">
        <div className="container-fluid">
          <div className="grid ">
            <div className="col comp-grid">
              <FilterTags filterController={filterController} />
              <div>
                <PageBreadcrumbs />
                <div className="page-records">
                  <CustomDataTable
                    loading={loading}
                    data={records}
                    selectionMode="checkbox"
                    selectedItems=""
                    onSelectionChange={(e) => setSelectedItems(e.value)}
                    sortField={sortBy}
                    sortOrder={sortOrder}
                    onSort={onSort}
                    rowClickHandler={handleRowClick}
                    emptyMessage={<EmptyRecordMessage />}
                    columns={[
                      { field: "name", header: FACILITY_NAME },
                      { field: "code", header: CODE },
                      { field: "contact_info", header: CONTACT_INFORMATION },
                    ]}
                  />
                </div>
                <PageFooter />
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};
const withDefaultProps = (Component) => {
  const WrappedComponent = (props) => {
    const { t } = useTranslation();
    const defaultProps = {
      primaryKey: "id",
      pageName: "org",
      apiPath: "org/get_all_orgs",
      routeName: "orglist",
      msgBeforeDelete: t("ARE_YOU_SURE_TO_DELETE_FACILITY"),
      msgTitle: "DELETE_FACILITY",
      msgAfterDelete: t("FACILITY_DELETED_SUCCESSFULLY"),
      showHeader: true,
      showFooter: true,
      paginate: true,
      isSubPage: false,
      showBreadcrumbs: true,
      exportData: false,
      importData: false,
      keepRecords: false,
      multiCheckbox: true,
      search: "",
      fieldName: null,
      fieldValue: null,
      sortField: "code",
      sortDir: "asc",
      pageNo: 1,
      limit: 10,
    };
    return <Component {...defaultProps} {...props} />;
  };

  return WrappedComponent;
};
export default withDefaultProps(OrgListPage);
